import React, { useMemo } from "react";
import { useTranslation } from "react-i18next";

import "../styles/SelectNewCyclistsBonus.css";

const SelectNewCyclistsBonus = ({
  selectedCyclists, // La liste complète de ton équipe
  setCyclistsBonus, // Fonction pour update le state du parent
  cyclistsBonus,    // Le tableau du bonus actuel (ex: [{id: 1...}])
  nextStep,
  prevStep,
  // Les props suivantes ne sont plus nécessaires pour la logique, mais gardées si besoin de compatibilité
  // selectedActualCyclists, 
  // selectedNewCyclists,
  // teamId,
  // saveData,
}) => {
  const { t } = useTranslation();

  // 1. Filtrer les cyclistes éligibles au bonus
  const pickable = useMemo(() => {
    if (!selectedCyclists) return [];
    
    return selectedCyclists.filter((c) => {
      // Sécurité pour éviter les nulls
      if (!c || c.cyclistId == null) return false;

      // RÈGLE MÉTIER : Est-ce qu'un bonus doit toujours avoir une valeur < 5 ?
      // Si oui, on garde cette ligne. Si tu veux pouvoir choisir N'IMPORTE QUI, supprime la ligne ci-dessous.
      return Number(c.finalValue || 0) < 5;
    });
  }, [selectedCyclists]);

  // Vérifie si un cycliste est actuellement sélectionné
  const hasBonus = (id) => (cyclistsBonus || []).some((c) => c?.cyclistId === id);

  // 2. Logique de sélection UNIQUE (Radio Button)
  const toggleBonus = (cyclist) => {
    const id = cyclist?.cyclistId;
    if (id == null) return;

    if (hasBonus(id)) {
      // Si on clique sur celui déjà sélectionné -> on le désélectionne
      setCyclistsBonus([]);
    } else {
      // Sinon, on remplace la sélection existante par ce nouveau cycliste
      setCyclistsBonus([cyclist]);
    }
  };

  // Validation : le bouton suivant n'est actif que si on a exactement 1 bonus
  const isValid = (cyclistsBonus || []).length === 1;

  return (
    <main className="select-new-cyclists-bonus">
      <div className="select-new-cyclists-bonus-shadow-container">
        <div className="select-new-cyclists-bonus-title">
          <h1>{t("swapBonusCyclist.pageTitle", "Choix du Bonus")}</h1>
          <div className="select-new-cyclists-bonus-shadow-mask-right"></div>
          <div className="select-new-cyclists-bonus-shadow-mask-bottom"></div>
        </div>
      </div>

      <div className="select-new-cyclists-bonus-header">
        <div className="select-new-cyclists-bonus-rules">
          <p>{t("swapBonusCyclist.pageHint", "Sélectionnez un coureur de votre équipe pour devenir votre bonus.")}</p>
        </div>

        <div className="select-new-cyclists-bonus-change-step">
          {/* Si tu veux permettre un retour, tu peux remettre prevStep */}
          <button onClick={prevStep} disabled={!prevStep} style={{ visibility: prevStep ? 'visible' : 'hidden'}}>
             {t("swapBonusCyclist.backBtn")}
          </button>
          
          <button 
            onClick={nextStep} 
            disabled={!isValid} // Désactivé tant qu'on n'a pas 1 seul coureur
            style={{ opacity: isValid ? 1 : 0.5, cursor: isValid ? 'pointer' : 'not-allowed' }}
          >
            {t("swapBonusCyclist.nextBtn")}
          </button>
        </div>
      </div>

      <div className="select-new-cyclists-bonus-pannel-view">
        <div className="select-new-cyclists-bonus-choice">
          <div className="select-new-cyclists-bonus-table-container">
            <table>
              <thead>
                <tr>
                  <th>{t("swapBonusCyclist.cols.rider")}</th>
                  <th>{t("swapBonusCyclist.cols.squad")}</th>
                  <th>{t("swapBonusCyclist.cols.country")}</th>
                  <th>{t("swapBonusCyclist.cols.worth")}</th>
                  <th>{t("swapBonusCyclist.cols.role")}</th>
                </tr>
              </thead>
              <tbody>
                {pickable.map((cyclist) => (
                  <tr
                    key={cyclist.cyclistId}
                    onClick={() => toggleBonus(cyclist)}
                    className={hasBonus(cyclist.cyclistId) ? "select-new-cyclists-bonus-table-selected-row" : ""}
                    style={{ cursor: "pointer" }}
                  >
                    <td>
                      <div className="select-new-cyclists-bonus-name-info">
                        <img
                          className="select-new-cyclists-bonus-flag-icon"
                          src={`${process.env.PUBLIC_URL}/flags/${(cyclist.nationality || "")
                            .normalize("NFD")
                            .replace(/[\u0300-\u036f]/g, "")
                            .replace(/ /g, "_")
                            .toLowerCase()}.png`}
                          alt={cyclist.nationality}
                          width="20"
                          height="20"
                        />
                        <span>{cyclist.name || (cyclist.firstName + " " + cyclist.lastName)}</span>
                      </div>
                    </td>
                    <td>{cyclist.team}</td>
                    <td>{cyclist.nationality}</td>
                    <td>{cyclist.finalValue}</td>
                    <td>{cyclist.speciality}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>

        {/* Panneau d'affichage du coureur sélectionné */}
        <div className="select-new-cyclists-bonus-line-container">
          {(cyclistsBonus || []).map((cyclist) => (
            <div className="select-new-cyclists-bonus-selected-cell" key={cyclist.cyclistId}>
              <div className="select-new-cyclists-bonus-selected-info">
                <img
                  src={`${process.env.PUBLIC_URL}/icons/cancel.png`}
                  className="select-new-cyclists-bonus-cancel-icon"
                  alt="Remove"
                  width="17"
                  height="17"
                  onClick={() => toggleBonus(cyclist)}
                />
                <h4>
                   {/* Drapeau optionnel ici aussi */}
                   {cyclist.name || (cyclist.firstName + " " + cyclist.lastName)}
                </h4>
                <p>{cyclist.team}</p>
                <p>
                  {t("swapBonusCyclist.worthLine")} <strong>{cyclist.finalValue}</strong>
                </p>
                <div
                  style={{
                    width: "100%",
                    height: "15px",
                    backgroundColor: cyclist.teamColor || "#ccc",
                    marginTop: "35px",
                    marginLeft: "auto",
                    marginRight: "auto",
                  }}
                ></div>
              </div>
            </div>
          ))}
          {/* Message si aucun bonus sélectionné pour guider l'utilisateur */}
          {cyclistsBonus.length === 0 && (
             <div style={{ padding: "20px", textAlign: "center", color: "#888" }}>
                 {t("swapBonusCyclist.noSelection", "Veuillez sélectionner un coureur dans la liste.")}
             </div>
          )}
        </div>
      </div>
    </main>
  );
};

export default SelectNewCyclistsBonus;